export { default } from './es/icons/ArrowRightOutlined';